"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESET_PASSWORD_COPY = void 0;
exports.RESET_PASSWORD_COPY = {
    RESET_PASSWORD_HEADER: 'Reset Password',
    RESET_PASSWORD_SUBTEXT: 'You can update your password here. Passwords must have at least 1 uppercase character, 1 lowercase character, 1 number, and be at least 8 characters long.'
};
//# sourceMappingURL=COPY.js.map